import { SET_STORY } from 'client/constants/actions';
import type { SpreadsheetRange, StoryModel } from 'types/story';

export type SetStoryPayload = {
	story: StoryModel;
	spreadsheetVariables?: SpreadsheetRange[];
};

export function setStory(payload: SetStoryPayload) {
	return {
		type: SET_STORY,
		payload,
	};
}
